import { render, staticRenderFns } from "./login-gate.vue?vue&type=template&id=73135c0f&scoped=true&"
import script from "./login-gate.vue?vue&type=script&lang=js&"
export * from "./login-gate.vue?vue&type=script&lang=js&"
import style0 from "./login-gate.vue?vue&type=style&index=0&id=73135c0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73135c0f",
  null
  
)

export default component.exports